var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"11b647b1340fbfd93af7a836609d703aaa694083"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"11b647b1340fbfd93af7a836609d703aaa694083"};
      